import { Link } from "wouter";
import { BrandIcon, Wordmark } from "../components/Brand";

/**
 * /for-merchants — Phase 28 public landing page for merchant signup.
 *
 * The pitch: a free STANDALONE tenant in under two minutes — phone
 * OTP verification only, no admin gating, no contract. From here the
 * merchant either starts the signup flow or jumps straight to the
 * existing /merchant/login if they already have an API token.
 */
export function ForMerchantsPage() {
  return (
    <div className="min-h-screen flex flex-col items-center px-6 pt-12 pb-16 max-w-md mx-auto text-center">
      <BrandIcon size={80} />
      <div className="mt-5">
        <Wordmark size="lg" />
      </div>
      <h1
        className="mt-8 text-3xl font-bold text-navy"
        data-testid="text-for-merchants-headline"
      >
        Run a small business in PH?
      </h1>
      <p className="mt-3 text-ink-dark text-lg leading-relaxed">
        Open a free Orbit merchant account in under two minutes. No setup
        fee, no contract — keep your customers coming back with points,
        stamps, and surprise rewards.
      </p>

      <ul className="mt-8 w-full text-left space-y-3 text-sm text-ink-dark">
        <li className="flex gap-2">
          <span className="font-semibold text-navy">•</span>
          <span>One-tap join QR for your customers — no app install.</span>
        </li>
        <li className="flex gap-2">
          <span className="font-semibold text-navy">•</span>
          <span>Points, stamps, vouchers, and surprise cards out of the box.</span>
        </li>
        <li className="flex gap-2">
          <span className="font-semibold text-navy">•</span>
          <span>Cashier dashboard works on any phone or tablet browser.</span>
        </li>
      </ul>

      <div className="mt-10 w-full flex flex-col gap-3">
        <Link
          href="/merchant/signup"
          className="btn-primary w-full text-center"
          data-testid="link-start-merchant-signup"
        >
          Create my merchant account
        </Link>
        <Link
          href="/merchant/login"
          className="btn-secondary w-full text-center"
          data-testid="link-merchant-already-have-account"
        >
          I already have an API token
        </Link>
        <Link
          href="/"
          className="text-sm text-navy underline mt-2"
          data-testid="link-back-to-customer"
        >
          Back to customer Orbit
        </Link>
      </div>

      <p className="mt-12 text-xs text-ink-dark/70">
        Need help? Contact M42 ops at{" "}
        <span className="font-mono">support@m42.ph</span>.
      </p>
    </div>
  );
}
